import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const ServiceCard = ({ category, index = 0, dark = false }) => (
  <Reveal delay={index * 0.08} className="h-full">
    <Link
      to={`/services#${category.slug}`}
      data-testid={`service-card-${category.slug}`}
      className={`group block h-full rounded-xl overflow-hidden border transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-18px_rgba(17,17,17,0.35)] ${
        dark ? "bg-coal border-white/10" : "bg-paper border-ink/10"
      }`}
    >
      <div className="relative overflow-hidden aspect-[16/10]">
        <img
          src={category.image}
          alt={category.imageAlt}
          loading="lazy"
          width={900}
          height={563}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent opacity-60" aria-hidden="true" />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between gap-3">
          <h3 className={`font-display font-bold text-xl ${dark ? "text-white" : "text-ink"}`}>{category.title}</h3>
          <span className="grid place-items-center w-9 h-9 rounded-full border border-copper/40 text-copper transition-all duration-300 group-hover:bg-copper group-hover:text-ink" aria-hidden="true">
            <ArrowUpRight size={16} />
          </span>
        </div>
        <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-white/55" : "text-mute"}`}>{category.blurb}</p>
      </div>
    </Link>
  </Reveal>
);
